<template>
  <div class="range">
    <div class="numValue" v-if="low !== undefined">
      {{ low }}
    </div>
    <div class="rangeWrapper">
      <div class="rangeMarker" :style="setLeft()"/>
      <div class="rangeBg"/>
    </div>
    <div class="numValue" v-if="high !== undefined">
      {{ high }}
    </div>
  </div>
</template>

<script>
export default {
  name: "priceRange",
  props: ['low', 'high', 'value'],
  methods: {
    setLeft() {
      return {left: this.value * 100 + '%'}
    }
  }
}
</script>

<style scoped lang="scss">
.range {
  position: relative;
  width: 160px;
  gap: 5px;
  align-items: center;
  justify-content: space-between;
  height: 6px;
  display: flex;

  .rangeMarker {
    transform: translateX(-50%) translateY(-25%);
    height: 9px;
    width: 3px;
    border-radius: 6px;
    background: var(--textColor);
    position: absolute;
  }

  .rangeWrapper {
    position: relative;
    width: 60px;
    height: 5px;
  }

  .rangeBg {
    width: 60px;
    height: 100%;
    flex: 1 0 60px;
    border-radius: 8px;
    background: linear-gradient(90deg, var(--red) 10%, var(--lightYellow) 50%, var(--green) 90%);
    opacity: .5;
  }

  .numValue {
    width: 40px;
    text-align: center;
  }
}
</style>
